'use es6';

import { OrderedMap } from 'immutable';
import curry from 'transmute/curry';
import map from 'transmute/map';
import { getChecker, getId } from './problem';
export const getAllProblems = (params, rankedProblems) => {
  return OrderedMap(map(p => [getId(p), getChecker(p)(params)], rankedProblems));
};
export const getAllProblemsCurried = curry((rankedProblems, params) => getAllProblems(params, rankedProblems));